"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dom_utils_1 = require("../../../../utils/dom-utils");
const collapse = (0, dom_utils_1.queryAll)('.collapse');
if (collapse.length > 0) {
    collapse.forEach((item) => {
        item.addEventListener('click', () => {
            const header = item.querySelector('.collapse__header');
            const content = item.querySelector('.collapse__content');
            header.classList.contains('collapse__header--collapsed') ? header.classList.remove('collapse__header--collapsed') : header.classList.add('collapse__header--collapsed');
            content.classList.contains('collapse__content--collapsed') ? content.classList.remove('collapse__content--collapsed') : content.classList.add('collapse__content--collapsed');
        });
    });
}
